const {store, AoflElement, clickTrackerMixin, CookieService} = aofljs;
/**
 * @summary HomeTabs
 * @class HomeTabs
 * @extends {AoflElement}
 */
class HomeTabs extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of HomeTabs.
   * Sets isPc property based on store value.
   *
   * @memberof HomeTabs
   */
  constructor() {
    super(store);
  }

  /**
   *
   * @readonly
   * @static
   * @memberof HomeTabs
   */
  static get properties() {
    return {
      isApp: String
    };
  }

  /**
   *
   *
   * @memberof HomeTabs
   */
  connectedCallback() {
    super.connectedCallback();
    if (this.isApp) {
      this.classList.add('is-app');
    } else {
      this.classList.remove('is-app');
    }
    this.academyUrl = `https://www.adventureacademy.com/?src_tag=aofl:abcmouse:nmhptab:1&tid=${CookieService.get('track')}&tap=abc`;
  }

  /**
   *
   * @readonly
   * @static
   * @memberof HomeTabs
   */
  static get is() {
    return 'home-tabs';
  }
}

window.customElements.define(HomeTabs.is, HomeTabs);



// WEBPACK FOOTER //
// ./home/en-US/js/home-tabs/home-tabs.js